"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var ui_components_1 = require("@l2p/ui-components");
var Step1_1 = __importDefault(require("./Step1"));
var Step2_1 = __importDefault(require("./Step2"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var SetSessionLimit = function (_a) {
    var onClose = _a.onClose;
    var _b = (0, react_1.useState)(0), step = _b[0], setStep = _b[1];
    var generateOptions = (0, react_1.useCallback)(function (count) {
        return Array.from({ length: count + 1 }, function (_, i) { return i; }).map(function (item) { return ({
            value: item,
            label: String(item),
        }); });
    }, []);
    var durationHoursOptions = generateOptions(12);
    var durationMinutesOptions = generateOptions(60);
    var _c = (0, swr_hooks_1.useSetSessionLimit)({
        successAction: onClose,
    }), setSessionLimit = _c.setSessionLimit, isSubmitting = _c.isSubmitting;
    var setNextStep = (0, react_1.useCallback)(function () {
        setStep(1);
    }, []);
    var setPrevStep = (0, react_1.useCallback)(function () {
        setStep(0);
    }, []);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        setSessionLimit({
            duration: (values.hours.value * 60 + values.minutes.value) * 60,
        });
    }, [setSessionLimit]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "525px", height: "auto", padding: "0", onClose: onClose, showClose: true },
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, render: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", null, step === 0 ? (react_1.default.createElement(Step1_1.default, { setNextStep: setNextStep, durationHoursOptions: durationHoursOptions, durationMinutesOptions: durationMinutesOptions })) : (react_1.default.createElement(Step2_1.default, { setPrevStep: setPrevStep, isSubmitting: isSubmitting })))));
            } })));
};
exports.default = SetSessionLimit;
